import React from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";

export default function AdminLayout() {
  return (
    <div className="flex min-h-screen bg-cream">
      <AdminSidebar />
      <main className="flex-1 min-w-0">
        <div className="p-6 md:p-10 max-w-[1600px]">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
